import React from 'react';
import { ExceptionQueueTable } from '../components/ExceptionQueueTable';

export function OversPage() {
  return (
    <ExceptionQueueTable
      title="Overs"
      subtitle="Excess stock from completed jobs — confirm the amount and storage location"
      blurb="Open a row to review the excess in Ace, confirm where it's stored, then mark it stored."
      predicate={r => !!r.overs_status}
      stageKey="overs"
    />
  );
}
